'use client'

import { css } from '@lastbrand/web-ui-styled-system/css'

// Figma grid band (nodes 6236:50100 desktop / 6236:52344 mobile): full-bleed section with `space/48`
// desktop horizontal gutters (mobile `space/16`). Vertical padding + the 1504 content cap live on the
// inner `dsContentClass`, mirroring the Figma `.Widget` (gutters) → `Content` (py + max-w) nesting.
export const dsSectionClass = css({
  display: 'flex',
  flexDirection: 'column',
  px: { base: 'space-16', lg: 'space-48' },
})

// Inner content frame: capped at the Figma `widget/max-w` 1504 and centred.
// Still deliberately divergent from the sibling reco bands (`product-reco-pdp.styles.ts` /
// `product-grid-carousel-pdp.styles.ts`, both 48/64 top, 48/100 bottom, gap 24/48): `lg` paddingTop
// (`space-100` vs their `space-64`) and the base gap (`space-32` vs their `space-24`) come from this
// band's own Figma variables — STRFRNT-16742 confirmed the two are not meant to be harmonised.
// The mobile paddingBottom WAS aligned to the siblings' `space-48` under STRFRNT-16809.
export const dsContentClass = css({
  display: 'flex',
  flexDirection: 'column',
  width: 'full',
  maxWidth: '1504px',
  marginInline: 'auto',
  gap: { base: 'space-32', lg: 'space-48' },
  paddingTop: { base: 'space-48', lg: 'space-100' },
  paddingBottom: { base: 'space-48', lg: 'space-100' },
})

// Title — the Figma "Widget title" eyebrow: Grosa Medium, UPPERCASE, 0.05em tracking. The DS `title-16`
// (`title/16`, used on BOTH breakpoints for this widget) already carries the uppercase + letter-spacing,
// so the source copy stays normal-case (CSS uppercases it). NOT the decorative ivy `-dec` serif.
export const dsTitleClass = css({
  textStyle: 'title-16',
  color: 'black',
  width: 'full',
  textAlign: 'left',
})

// Row gap is a flat Figma `space/32` at every breakpoint, so it is declared apart from the responsive
// column gap — the `gap` shorthand would let the column value leak into the rows.
export const dsGridClass = css({
  display: 'grid',
  width: 'full',
  gridTemplateColumns: { base: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' },
  columnGap: { base: 'space-16', lg: 'space-24' },
  rowGap: 'space-32',
})
